(() => {
  const initializeTabs = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.tabsReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    root.dataset.tabsReady = 'true';

    const activateTab = (nextTab, moveFocus = false) => {
      tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
      });

      if (moveFocus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    activateTab(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };

  const initializeQuestions = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.questionsReady === 'true') return;

    const questions = Array.from(root.querySelectorAll('.self-product-content__question'));
    if (!questions.length) return;

    root.dataset.questionsReady = 'true';
    questions.forEach((question, index) => {
      if (question.querySelector('.self-product-content__question-toggle')) return;

      const heading = question.querySelector('h3');
      const answer = question.querySelector('p');
      if (!heading || !answer) return;

      const questionId = `self-product-question-${Date.now()}-${index}`;
      const button = document.createElement('button');
      button.className = 'self-product-content__question-toggle';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', questionId);
      button.innerHTML = `<span>${heading.innerHTML}</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      answer.id = questionId;
      answer.hidden = true;
      heading.replaceWith(button);

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        answer.hidden = expanded;
      });
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-self-product-tabs]').forEach(initializeTabs);
    scope.querySelectorAll('[data-self-product-questions]').forEach(initializeQuestions);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
